













import Vue from "vue";
import BranchHistoryTimeline from "@/components/BranchHistoryTimeline.vue";

export default Vue.extend({
    components: { BranchHistoryTimeline },
    data() {
        return { showBranchHistory: false };
    },
});
